import React, {useState} from 'react'
import Logo from '../assets/logo1.png';
import Loading from '../general/Loading';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
            const [formData, setFormData] = useState({
              mobile: '',
              pass: '',
            })
        const [loading, setLoading] = useState(false);
        const [responseMsg, setResponseMsg] = useState('');
        const navigate = useNavigate();
    
                      // Handle form data change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


    const handleLogin = async (e) => {
    e.preventDefault();
    setResponseMsg('');

    if (formData.mobile === '9876543210' && formData.pass === '9898') {
      // If they match, navigate to the dashboard
      localStorage.setItem('isLoggedIn', 'true');
      setResponseMsg('Login Successful');
      setTimeout(() => {
        setResponseMsg('');
        navigate('/dashboard');
        // window.location.reload();
        }, 1000)
    } else {
      setResponseMsg('Invalid username or password');
      setTimeout(() => {
        setResponseMsg('');
      }, 2000)
    }
  }


  return (
    <>
      <section className='px-3 admin-login-outer vh-100'>
        <div className='admin-login col-lg-4 mx-auto'>

<img src={Logo} alt='Logo' className='header-img' /><br /><br />

<span className='login-text'>Admin Login</span>

<form class="row g-3 mt-4" onSubmit={handleLogin}>
{responseMsg && <p className='my-0 fw-semibold fm-dm para-text'>{responseMsg}</p>}
  <div class="col-12">
    <input type="tel" class="login-control" id="inputMobile4" name='mobile' maxLength='10' onChange={handleChange} value={formData.mobile} placeholder='Mobile Number' />
  </div>
  <div class="col-12">
    <input type="password" class="login-control" id="inputPassword4" name='pass' onChange={handleChange} value={formData.pass} placeholder='Your Password' />
  </div>
  <div class="col-12 mt-4">
    <button type="submit" class="login-btn">Sign in</button>
  </div>
</form>

</div>      </section>

{loading && <Loading setLoading={setLoading} />}
    </>
  )
}

export default AdminLogin
